/* eslint-disable no-bitwise */
/**
 * Returns an object representing a bitmask providing helper functions.
 * @param {number} value
 */
const bitmask = (value) => ({
  /**
   * Returns a new `bitmask` with the current `value` bitwise-and `n`
   * @param {number} n
   */
  and: (n) => bitmask(value & n),

  /**
   * Returns a new `bitmask` with the current `value` bitwise-or `n`
   * @param {number} n
   */
  or: (n) => bitmask(value | n),

  /**
   * Returns a new `bitmask` with the current `value` bitwise-not `n`
   * @param {number} n
   */
  not: (n) => bitmask(value & ~n),

  /**
   * Returns a new `bitmask` with the current `n` value toggled
   * @param {number} n
   */
  toggle: (n) => ((value & n) === n ? bitmask(value & ~n) : bitmask(value | n)),

  /**
   * Returns a new `bitmask` with the current `n` either `or` or `not` based on `on`.
   * @param {number} n
   * @param {boolean} on
   */
  set: (n, on) => bitmask(value)[on ? 'or' : 'not'](n),

  /**
   * Returns `true` if the current `value` has ANY bits in `n` enabled.
   * @param {number} n
   */
  some: (n) => (value & n) !== 0,

  /**
   * Returns `true` if the current `value` has ALL bits in `n` enabled.
   * @param {number} n
   */
  every: (n) => (value & n) === n,

  /**
   * Returns the current `value` of the bitmask.
   */
  get value() {
    return value;
  },
});

export default bitmask;
